import { Helmet } from 'react-helmet';
import { CountriesContainer } from '../components/countries.container';

export const ISConfigStateCountries: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Is config - Countries</title>
      </Helmet>
      <CountriesContainer />
    </>
  );
};
